import { render, staticRenderFns } from "./registerScreen.vue?vue&type=template&id=26fd351e"
import script from "./registerScreen.vue?vue&type=script&lang=js"
export * from "./registerScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports